"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { MessageSquare, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden py-24 px-4">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--color-secondary-hover)_0%,_var(--color-background)_70%)]" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {}
        <div className={`mb-8 transition-all duration-500 ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="inline-flex flex-col items-center gap-3">
            <img src="https://aware-ocelot.10web.cloud/wp-content/uploads/2026/02/logo.png" alt="FAKTA INTEGRITAS" className="object-contain !text-[hsl(35,88%,47%)] !h-[200px] !w-[250px]" />
            <div className="flex flex-col items-center">
              
              
              <div className="w-32 h-1 mt-2 rounded-full !bg-[hsl(27,96%,61%)]" />
            </div>
          </div>
        </div>

        {}
        <h1 className="font-display font-extrabold text-5xl tracking-tight leading-tight mb-6 transition-all duration-500 delay-100 opacity-100 translate-y-0 !text-[hsl(35,88%,47%)] sm:text-6xl md:text-7xl lg:text-8xl">
          FAKTA INTEGRITAS
        </h1>

        {}
        <p className={`text-foreground text-xl sm:text-2xl md:text-3xl font-medium mb-4 transition-all duration-500 delay-200 ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Konsultan Hukum, Advokat, Mediator
        </p>

        {}
        <p className={`text-muted-foreground text-base sm:text-lg md:text-xl max-w-3xl mx-auto mb-10 leading-relaxed transition-all duration-500 delay-300 ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Menegakkan Kebenaran, Menjaga Keadilan Substantif dengan Integritas
          Moral dan Profesionalitas Tinggi
        </p>

        {}
        <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-500 delay-[400ms] ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <Link to="https://wa.me/6282310335547" newTab>
            <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 rounded-md has-[>svg]:px-4 text-foreground-primary transition-all duration-300 font-bold uppercase tracking-wide px-8 py-6 text-base group !bg-[hsl(35,88%,47%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary-hover hover:shadow-[0_0_20px_rgba(253,191,0,0.4)]">
              <MessageSquare className="mr-2 size-5 group-hover:scale-110 transition-transform" />
              Konsultasi via WhatsApp
            </Button>
          </Link>

          {}
          <Link to="#layanan-hukum-kami">
            <Button size="lg" variant="outline" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 rounded-md has-[>svg]:px-4 border-2 border-primary bg-transparent transition-all duration-300 font-bold uppercase tracking-wide px-8 py-6 text-base group !text-[hsl(35,88%,47%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-primary/10 hover:border-primary-hover hover:border-[3px]">
              Lihat Layanan Kami
              <ArrowRight className="ml-2 size-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}